import React from 'react';

import '../fonts.css';
import './Main.css';

const Main: React.FC = () => {
    return (
        <div className='main-headings'>
            <h1 className='mainName ultra'>Reagan Middlebrook</h1>
            <h2 className='mainTitle cinzel'>Software Engineer</h2>
        </div>
    );
}

export default Main;
